const state = {
  informations: {},
};

export { state };
